import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import LazyLoad from 'react-lazyload';
const SchoolCabinet = () => {
   useEffect(() => {
      document.title = 'School Cabinet - St. Francis Xavier School';
   }, []);
   return (
      <>
         <Header />
         <div className="innerslide">
            <ul className="breadcrumb">
               <li><Link to="/"> Home</Link> </li>
               <li>School</li>
               <li>School Cabinet</li>
            </ul>
         </div>
         <section className="innerbody">
            <div className="container schoolcabinet">
               <div className="row">
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/headboy.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ARYAN    </h3>
                        <h4>(HEAD BOY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/headgirl.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>APEKSHA   </h3>
                        <h4>(HEAD GIRL)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrheadboy.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>VAIBHAV   </h3>
                        <h4>(JR HEAD BOY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrheadgirl.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DEEPTI  </h3>
                        <h4>(JR HEAD GIRL)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/viceheadboy.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DEVEN   </h3>
                        <h4> (VICE-HEAD BOY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/viceheadgirl.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>YASHIKA   </h3>
                        <h4>  (VICE-HEAD GIRL)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/stageSecretary.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>HAMMAD   </h3>
                        <h4>(STAGE SECRETARY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/stageSecretary1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>MAHI    </h3>
                        <h4>(STAGE SECRETARY)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrsecretary1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>YASH   </h3>
                        <h4>(JR STAGE SECRETARY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrsecretary.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ADITI  </h3>
                        <h4>(JR STAGE SECRETARY)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/disciplineminister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ISHAAN   </h3>
                        <h4> (DISCIPLINE MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/disciplineminister1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>RIYA    </h3>
                        <h4> (DISCIPLINE MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrdisciplineminister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>PAYAL</h3>
                        <h4>(JR DISCIPLINE MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrdisciplineminister1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>RUDRA KAMRA </h3>
                        <h4>(JR DISCIPLINE MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/curltural-minister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ARYAN   </h3>
                        <h4>(CULTURAL MINISTER)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/cultural-minister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KAVYA </h3>
                        <h4> (CULTURAL MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/academic-minister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>JAI BALODA    </h3>
                        <h4>(ACADEMIC MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/academic-minister1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KAVYA SINGH    </h3>
                        <h4>(ACADEMIC MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/health-minister.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KANISHKA</h3>
                        <h4> (HEALTH & ENVIROMENT MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/health-minister1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>PRANAV </h3>
                        <h4>(HEALTH & ENVIROMENT MINISTER)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/sports-captain.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>PRINCE </h3>
                        <h4>  (SPORTS CAPTAIN)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/sports-captain1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SHANVI  </h3>
                        <h4>  (SPORTS CAPTAIN)</h4>
                     </article>
                  </div>








                  <div className="clr"></div>
                  <div className="col-lg-12">
                     <h2 className="text-center m-4"><small> Gandhi House</small></h2>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>PUNIT </h3>
                        <h4>( HOUSE CAPTAINS)</h4>
                     </article>
                  </div>



                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>BHAVYA </h3>
                        <h4> ( HOUSE CAPTAINS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiViceCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>HARKEERAT  </h3>
                        <h4>( VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-3.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SIYA </h3>
                        <h4> ( VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiSportsCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KETAN  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>






                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-4.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SOMYA  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>CHAHAK</h3>
                        <h4> (PREFECTS) </h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiViceCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ISHIKA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiSportsCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KANISHK  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SAMYAN  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-5.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>HARDIK AGGARWAL  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>













                  <div className="clr"></div>
                  <div className="col-lg-12">
                     <h2 className="text-center m-4"><small>RAMAN HOUSE</small></h2>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanSportsCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>MEHUL  </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>RASHI  </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanViceCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>MADHAV  </h3>
                        <h4>(VICE CAPTAINS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-5.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SUNIDHI  </h3>
                        <h4> (VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-4.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SARANSH </h3>
                        <h4> (SPORTS CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanSportsCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>MANAT  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DEVIKA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanViceCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KIRTIKA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>






                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>RUDRA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>RUDRA </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-12">
                     <h2 className="text-center m-4"><small>TERESA HOUSE</small></h2>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>NAMAN  </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-4.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>VAISHNAVI </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>AVANI  </h3>
                        <h4>(VICE CAPTAINS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-5.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>VIVEK    </h3>
                        <h4>(VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaViceCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DEEPANSHU  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>JIYA  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>



                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>AARAV  </h3>
                        <h4> (PREFECTS) </h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>HASHMITA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KELVIN </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SAKSHI </h3>
                        <h4> (PREFECTS)</h4>
                     </article>
                  </div>





                  <div className="col-lg-12">
                     <h2 className="text-center m-4"><small>TAGORE HOUSE</small></h2>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-4.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>PIYUSH  </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-7.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>YASHIKA    </h3>
                        <h4>(HOUSE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-5.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>SAMAR  </h3>
                        <h4> (VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DIYA </h3>
                        <h4>(VICE CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-3.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>NITIKA  </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>


                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-6.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>UDAY   </h3>
                        <h4>(SPORTS CAPTAINS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreCaptain-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>ALVIN  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreViceCaptain-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DHANVI  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-1.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>HEENAL </h3>
                        <h4> (PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-2.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>KENIT  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-8.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>DIPESH     </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-6">
                     <article>
                        <LazyLoad>
                           <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-9.JPG"
                              alt="sfxhisar" className="img-fluid mx-auto d-block" /></LazyLoad>
                        <h3>MIHIKA  </h3>
                        <h4>(PREFECTS)</h4>
                     </article>
                  </div>



               </div>
            </div>
         </section>
         <Footer />
      </>
   );
}

export default SchoolCabinet;
